/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Composition_ExtrasInputs */

const en_attribute_composition_extras = /** @type {(inputs: Attribute_Composition_ExtrasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Composition extras`)
};

/**
* | output |
* | --- |
* | "Composition extras" |
*
* @param {Attribute_Composition_ExtrasInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_composition_extras = /** @type {((inputs?: Attribute_Composition_ExtrasInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Composition_ExtrasInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_composition_extras(inputs)
});